const getters = {
    token: state => state.user.token,
    roles: state => state.user.permissionList,
    permission_routes: state => state.permission.routes,
  }
  
  export default getters